import { render } from "./Swatches.vue?vue&type=template&id=0a7f11d6&scoped=true"
import script from "./Swatches.vue?vue&type=script&lang=js"
export * from "./Swatches.vue?vue&type=script&lang=js"

import "./Swatches.vue?vue&type=style&index=0&id=0a7f11d6&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7f11d6"]])

export default __exports__